module.exports = __webpack_public_path__ + "media/newstyle/images/cta-desktop_es-11d50237c43f4f3473d4772b8d01fbd8.jpg";